<script setup lang="ts">
const { columns = 1 } = defineProps<{
  columns?: number
}>()

defineSlots<{
  default: string
}>()
</script>

<template>
  <div class="input-grid grid" :columns>
    <slot></slot>
  </div>
</template>

<!-- TODO: change this Anti-Pattern with properties or use some other solution -->
<style scoped>
.input-grid {
  --cols: v-bind(columns);
  grid-template-columns: repeat(var(--cols), 1fr);
}

.input-grid > * {
  border: 1px solid rgb(var(--tw-line-black-200));
  border-radius: 0;
  min-width: 0;
}
.input-grid:deep([error='true']) {
  border-color: rgb(var(--tw-line-radical_red-500));
}
.input-grid:deep(> * *) {
  border: none;
}
.input-grid :deep(.spinner) {
  --borderWidth: 5px;
  width: var(--size);
  aspect-ratio: 1;
  border-radius: 50%;
  border: var(--borderWidth) solid rgb(var(--tw-line-black-950) / 0.3);
  border-bottom: var(--borderWidth) solid rgb(var(--tw-line-black-950) / 0.15);
  padding: calc(var(--size) / 2);
}
.input-grid:deep(.combobox) {
  padding-top: 0.375rem;
}
.input-grid:deep(.combobox label) {
  padding-left: 1.25rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  color: rgb(var(--tw-content-black-400));
}
.input-grid:deep(.combobox .options) {
  margin: 0;
}
.input-grid[columns='1']:deep(> *:first-child) {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

.input-grid[columns='1']:deep(> *:last-child) {
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}

.input-grid[columns='2']:deep(> *:first-child:not(.col-span-2)) {
  border-top-left-radius: 0.5rem;
}
.input-grid[columns='2'] :deep(> *:not(.col-span-2) + *:nth-child(2):not(.col-span-2)) {
  border-top-right-radius: 0.5rem;
}
.input-grid[columns='2']:deep(> *:first-child.col-span-2) {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.input-grid[columns='2'] :deep(> *:last-child:not(.col-span-2)) {
  border-bottom-right-radius: 0.5rem;
}
.input-grid[columns='2']:not(:has(*:last-child.col-span-2))
  :deep(> *:nth-last-child(2):not(.col-span-2)) {
  border-bottom-left-radius: 0.5rem;
}
.input-grid[columns='2'] :deep(> *:last-child.col-span-2) {
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
</style>
